<template>

  <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3 mt-3">
  <v-layout align-center style="min-height: 48px;" v-if="box.title || box.pages[1]">
    <v-flex class="text-xs-left" v-if="box.title">
      <div><h3 class="title pl-3">{{box.title}}</h3></div>

    </v-flex>
    <v-flex >
          <v-tabs v-if="box.pages[1]"
            right
            v-model="tabs"
            color="transparent"
            slider-color="transparent"
          >
            <v-tab
              v-for="(page, i) in box.pages"
              :key="'dots-'+i"
              ripple
            >
              ⬤

            </v-tab>

          </v-tabs>

    </v-flex>
  </v-layout>
  <v-card style="border-radius: 3px; border: 1px solid lightgray;" class="elevation-0">

      <v-layout
        text-xs-left
        wrap
      >

        <v-flex v-bind:md12="expand === 0" v-bind:md8="expand !== 0" xs12 order-md2 order-xs2 class="animate-all">

          <v-tabs-items v-model="tabs" style="border-radius: 3px; overflow: hidden">
            <v-tab-item
              v-for="(page, i) in box.pages"
              :key="'page-'+i"
            >

      <v-card-text style="height: 100%;">
        <v-layout align-space-around justify-space-around column fill-height>
          <v-flex class="mb-3" v-if="expand===null">
        <div><h3 class="headline mb-3">{{page.title}}</h3></div>
            <div class="body-2" ><span v-if="page.intro">{{ page.intro }}</span><span v-else>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></div>
          </v-flex>
          <v-flex  style="max-height: 56px;">
        <v-layout align-end>
          <v-flex>
          <v-btn v-if="expand===null" class="ma-0 " dark depressed color="red darken-1" @click="expand=0">Learn More</v-btn>
            <v-btn v-else class="ma-0" dark outline="" color="grey darken-3" @click="expand=null">Hide Details</v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn depressed  class="ma-0 red--text text--darken-1" color="transparent" v-if="box.pages[1]" @click="next">next</v-btn>
          </v-flex>
        </v-layout>
        </v-flex>
        </v-layout>
    </v-card-text>

    </v-tab-item>
  </v-tabs-items>

        </v-flex>
        <v-flex v-bind:xs12="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs'" order-md1 order-xs1 :class="{'grey darken-3': expand !== 0, 'white': expand === 0, 'animate-all': 1}">
          <v-img v-if="expand !== 0 || ($vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs')" style="min-height: 100%;"
                 :src="require('@/assets/'+image)"
                 aspect-ratio="2.75"
          ></v-img>
        </v-flex>

        <v-flex xs12 order-xs3>
<div>
          <v-expansion-panel v-model="expand" class="elevation-0">
            <v-expansion-panel-content
              v-for="(item,i) in 1"
              :key="i"
            >

              <v-card>
                <FullPage :images="images" :content="content" :title="title"  :page="page" :intro="intro"></FullPage>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
</div>
        </v-flex>

      </v-layout>

  </v-card>

</v-flex>

</template>

<script>

import FullPage from '../components/FullPage'

export default {
  components: {
    FullPage
  },
  props: {
    box: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      image: 'transparent.png',
      content: undefined,
      page: 0,
      intro: undefined,
      title: undefined,
      images: [],
      tabs: 0,
      expand: null
    }
  },
  mounted () {
    this.updateContent()
  },
  methods: {
    next () {
      const active = parseInt(this.tabs)
      this.tabs = (active < 2 ? active + 1 : 0)
    },
    updateContent () {
      if (this.box.pages[this.tabs]) {
        this.page = this.tabs
        this.content = this.box.pages[this.tabs].content
        this.intro = this.box.pages[this.tabs].intro
        this.title = this.box.pages[this.tabs].title
        if (this.box.pages[this.tabs].images) {
          if (this.box.pages[this.tabs].images[0].source) {
            this.image = this.box.pages[this.tabs].images[0].source
          } else {
            this.image = 'transparent.png'
          }
          this.images = this.box.pages[this.tabs].images
        } else {
          this.image = 'transparent.png'
          this.content = undefined
          this.images = []
          this.intro = undefined
          this.title = undefined
        }
      }
    }
  },
  watch: {
    'tabs': function () {
      // this.expand = null
      this.updateContent()
    }
  }
}
</script>

<style>
  .v-expansion-panel__header {
    padding: 16px;
  }

  .v-tabs__item--active {
    color: red;
  }

  .v-window__container--is-active, .v-window__container, .v-window-item, .v-window {
    height: 100% !important;
  }

  .animate-all {
    -webkit-transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
</style>
